import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useThemeStore } from '../store/themeStore';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function LetterPractice() {
  const { i18n } = useTranslation();
  const { theme } = useThemeStore();
  const iframeRef = useRef(null);
  const savedProgressRef = useRef(null); // fetched from the server, applied once the iframe is ready
  const iframeReadyRef = useRef(false);
  const appliedRef = useRef(false);

  const syncLang = () => {
    const win = iframeRef.current?.contentWindow;
    if (win && typeof win.setTracerLang === 'function') {
      win.setTracerLang(i18n.language);
    }
  };

  const syncTheme = () => {
    const win = iframeRef.current?.contentWindow;
    if (win && typeof win.setTracerTheme === 'function') {
      win.setTracerTheme(theme);
    }
  };

  const trySyncProgress = () => {
    if (appliedRef.current) return;
    const win = iframeRef.current?.contentWindow;
    if (!iframeReadyRef.current || !win || typeof win.setTracerProgress !== 'function') return;
    if (!savedProgressRef.current) return;
    win.setTracerProgress(savedProgressRef.current);
    appliedRef.current = true;
  };

  const handleLoad = () => {
    iframeReadyRef.current = true;
    syncLang();
    syncTheme();

    // the tracer reports its own state whenever a letter is completed/reset — persist it
    const win = iframeRef.current?.contentWindow;
    if (win) {
      win.onTracerProgressChange = (progress) => {
        const token = localStorage.getItem('token');
        if (!token) return;
        axios
          .post(`${API_URL}/letters/progress`, progress, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .catch((err) => console.error('Failed to save letter progress:', err));
      };
    }

    trySyncProgress();
  };

  // the tracer has no language switcher of its own — the site's is the single source of truth
  useEffect(() => {
    syncLang();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  // ...and no day/night toggle of its own either — mirror the site's theme into it
  useEffect(() => {
    syncTheme();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    axios
      .get(`${API_URL}/letters/progress`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        savedProgressRef.current = res.data;
        trySyncProgress();
      })
      .catch((err) => console.error('Failed to load letter progress:', err));
  }, []);

  return (
    <div className="w-full h-full bg-[#faf8f4] dark:bg-[#0c1512]">
      <iframe
        ref={iframeRef}
        src="/arabic-tracer.html"
        title="Arab harflarini yozish"
        className="w-full h-full border-0"
        onLoad={handleLoad}
      />
    </div>
  );
}

export default LetterPractice;
